<!-- 实名认证身份证-人脸 -->
<template>
  <div class='verifieed-step pad-side20'>
    <TheVerifyTypeNew :step="0"/>
    <TheVerifyIDCard @confirm="confirm" />
  </div>
</template>

<script>
import TheVerifyIDCard from '@/components/TheVerifyIDCard.vue';
import TheVerifyTypeNew from '@/components/TheVerifyTypeNew.vue';
import { reqMobileCheck } from "@/api";
import { mapState } from 'vuex';

export default {
  name: 'VerifiedStep',

  components: {
    TheVerifyIDCard,
    TheVerifyTypeNew,
  },

  data () {
    return {
    };
  },

  computed: {
    ...mapState(['userInfo', 'OCRData'])
  },

  created() {
    this.$store.dispatch('getSignTicket')
  },

  methods: {
    confirm() {
      let path = localStorage.getItem('verifyPath')
      if(path === '/verified-result2') {
        // let { OCRData, userInfo } = this;
        // reqMobileCheck({idNo: OCRData.idcard, phoneNo: userInfo.phoneNo, name: OCRData.name}).then(res => {
          this.$router.push('/verified-step2')
        // })
      }else if(path === '/free-loan/bankcard-bind') {
        this.$router.push('/verified-step2')
      }
      
    }
  },
}

</script>

<style lang='less' scoped>
.verifieed-step {
  min-height: 100vh;
  background-color: #F5F5F5;
}
</style>